import { Modal, Button, Row, Col } from "react-bootstrap";
import { modal } from "@/utils/constant";

function StartRound2Modal({ show, hide, loading, onConfirm }) {
  return (
    <Modal
      show={show}
      onHide={() => !loading && hide()}
      size="lg"
      centered
    >
      <Modal.Header className="bg-secondary" closeButton={!loading}>
        <Modal.Title>{modal?.startRound2ModalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-10 px-lg-14">
        <p className="mb-3" style={{ textAlign: "justify" }}>
          {modal?.importantModalBody} <b>{modal?.importantModalBreakout}</b>
        </p>
        <p className="mb-3" style={{ textAlign: "justify" }}>
          {modal?.startRound2ModalBody}
        </p>
        <Row className="mt-8">
          <Col xs="7">
            <Button
              variant="secondary"
              className="font-semibold w-full"
              disabled={loading}
              onClick={onConfirm}
            >
              {loading ? "Starting…" : modal?.importantModalButtonText}
            </Button>
          </Col>
          <Col xs="5">
            <Button
              variant="outline-primary"
              className="font-semibold w-full"
              disabled={loading}
              onClick={hide}
            >
              {modal?.cancle}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default StartRound2Modal;
